/* eslint-disable no-param-reassign */
/* eslint-disable no-underscore-dangle */
/* eslint-disable import/no-extraneous-dependencies */
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Formik, Field } from 'formik';
import {
  Button,
  Box,
  CircularProgress,
  TextField,
  Modal,
  Card,
  CardContent,
  CardActions,
  CardHeader,
  IconButton,
  InputAdornment,
  Grid,
  Autocomplete,
  // Tooltip,
  Chip
} from '@mui/material';
import HighlightOffOutlinedIcon from '@mui/icons-material/HighlightOffOutlined';
import MailOutlineOutlinedIcon from '@mui/icons-material/MailOutlineOutlined';
import PhoneOutlinedIcon from '@mui/icons-material/PhoneOutlined';
import { Close } from '@mui/icons-material';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import { useDispatch, useSelector } from 'react-redux';
import DatePicker from 'react-datepicker';
import dateFormat from 'dateformat';
import 'react-datepicker/dist/react-datepicker.css';
import { ValidateClient } from '../../assets/validation';
import EmailChipsField from '../../components/EmailChipsField';
import globalAction from '../../store/actions/GlobalAction';
import DeptAction from '../../store/actions/DepartmentAction';
import CurrencyAction from '../../store/actions/CurrencyAction';
import ClientAction from '../../store/actions/ClientAction';
import CompanyAction from '../../store/actions/CompanyAction';
import PaymentAction from '../../store/actions/PaymentAction';
// import { technologyAction } from "../../../redux/actions/technologyAction";

function ClientAdd({ openmodal, onCloseModal }) {
  /* Modal Style */
  // const [drawerOpen, setDrawerOpen] = React.useState(false);
  const dispatch = useDispatch();

  const { countryData, stateData, isLoading } = useSelector((state) => state.global);
  const { activeDeptData } = useSelector((state) => state.department);
  const { currencyActiveData } = useSelector((state) => state.currency);
  const { activeCompanyData } = useSelector((state) => state.company);
  const { paymentMethodData } = useSelector((state) => state.payment);

  useEffect(() => {
    dispatch(globalAction.getCountryStatus());
    dispatch(DeptAction.getActiveItem());
    dispatch(CurrencyAction.getActiveItem());
    dispatch(CompanyAction.getActiveItem());
    dispatch(PaymentAction.getPaymentMethod());
  }, [dispatch]);

  // useEffect(() => {
  //   setDrawerOpen(openmodal);
  // }, [openmodal]);

  const handleCountryChange = (countryId) => {
    dispatch(globalAction.getStateStatus(countryId));
  };

  return (
    <Modal
      variant="temporary"
      anchor="right"
      open={openmodal}
      sx={{
        flexShrink: 0,
        zIndex: 1205
      }}
    >
      <Box className="largeModal">
        <Formik
          initialValues={{
            company_id: null,
            first_name: '',
            last_name: '',
            email: '',
            secondary_email: [],
            address_1: '',
            address_2: '',
            phone: '',
            department_id: [],
            country_id: null,
            state_id: null,
            city: '',
            postal_code: '',
            currency_id: null,
            payment_method_id: [],
            contract_date: null
          }}
          // enableReinitialize
          validationSchema={ValidateClient}
          onSubmit={(values, { setErrors, setSubmitting }) => {
            const newValues = { ...values };
            if (newValues && newValues.department_id.length > 0) {
              const ids = newValues.department_id.map((item) => item._id);
              const idString = ids.join(',');
              newValues.department_id = idString;
            }
            if (newValues.company_id) {
              newValues.company_id = newValues.company_id._id;
            }
            if (newValues.country_id?._id) {
              newValues.country_id = newValues.country_id._id;
            }
            if (newValues.state_id?._id) {
              newValues.state_id = newValues.state_id._id;
            }
            if (newValues.currency_id?._id) {
              newValues.currency_id = newValues.currency_id._id;
            }
            if (newValues.payment_method_id?.length > 0) {
              newValues.payment_method_id = newValues.payment_method_id.map((item) => item._id);
            }
            if (newValues.contract_date) {
              newValues.contract_date = dateFormat(newValues.contract_date, 'yyyy-mm-dd');
            }
            dispatch(ClientAction.add(newValues, setErrors, setSubmitting, onCloseModal));
          }}
        >
          {({
            errors,
            touched,
            values,
            handleChange,
            handleBlur,
            handleSubmit,
            handleReset,
            isSubmitting,
            setFieldValue
          }) => (
            <form onSubmit={handleSubmit}>
              <Card>
                <CardHeader
                  sx={{ textAlign: 'left !important' }}
                  title="Add Client"
                  action={
                    <IconButton
                      aria-label="settings"
                      onClick={() => {
                        onCloseModal();
                      }}
                    >
                      <Close />
                    </IconButton>
                  }
                />
                <CardContent>
                  <Grid container columnSpacing={2} rowSpacing={0} alignItems="stretch">
                    <Grid item xs={4} xl={4}>
                      <Field
                        name="company_id"
                        component={Autocomplete}
                        className="CurrencyField"
                        options={activeCompanyData ?? []}
                        // disableClearable
                        value={values.company_id}
                        onChange={(e, newvalue) => {
                          if (newvalue) {
                            setFieldValue('company_id', newvalue);
                          } else {
                            setFieldValue('company_id', null);
                          }
                        }}
                        loading={isLoading}
                        getOptionLabel={(option) => option.name}
                        renderOption={(props, option) => {
                          return (
                            <li {...props} key={option._id}>
                              {option.name}
                            </li>
                          );
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            name="company_id"
                            error={touched.company_id && !!errors.company_id}
                            helperText={touched.company_id && errors.company_id}
                            label="Select Company"
                            placeholder="Search Company"
                            variant="outlined"
                            margin="normal"
                            required={false}
                            InputLabelProps={{ required: true }}
                          />
                        )}
                      />
                    </Grid>
                    <Grid item xs={4} xl={4}>
                      <TextField
                        error={errors.first_name && touched.first_name}
                        label="First Name"
                        className=""
                        fullWidth
                        name="first_name"
                        value={values.first_name}
                        // maxRows={4}
                        placeholder="Enter Contact First Name"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        helperText={errors.first_name && touched.first_name && errors.first_name}
                        margin="normal"
                        variant="outlined"
                        required={false}
                        InputLabelProps={{ required: true }}
                      />
                    </Grid>
                    <Grid item xs={4} xl={4}>
                      <TextField
                        error={errors.last_name && touched.last_name}
                        label="Last Name"
                        className=""
                        fullWidth
                        name="last_name"
                        value={values.last_name}
                        // maxRows={4}
                        placeholder="Enter Contact Last Name"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        helperText={errors.last_name && touched.last_name && errors.last_name}
                        margin="normal"
                        variant="outlined"
                        required={false}
                        InputLabelProps={{ required: true }}
                      />
                    </Grid>
                    <Grid item xs={4} xl={4}>
                      <TextField
                        id="email"
                        fullWidth
                        label="Email ID"
                        name="email"
                        margin="normal"
                        placeholder="Enter Email ID"
                        value={values.email}
                        onChange={handleChange}
                        onBlur={(e) => {
                          const val = (e.target.value || '').replace(/\s+/gi, '');
                          setFieldValue(e.target.name, val.trim());
                          handleBlur(e);
                        }}
                        error={errors.email && touched.email}
                        helperText={errors.email && touched.email && errors.email}
                        required={false}
                        InputLabelProps={{ required: true }}
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="start">
                              <IconButton
                                aria-label="toggle password visibility"
                                edge="end"
                                disabled
                              >
                                <MailOutlineOutlinedIcon />
                              </IconButton>
                            </InputAdornment>
                          )
                        }}
                      />
                    </Grid>
                    <Grid item xs={4} xl={4}>
                      <EmailChipsField
                        name="secondary_email"
                        label="Secondary Email"
                        placeholder="Enter Email"
                        value={values.secondary_email}
                        errors={errors.secondary_email}
                        onChange={(newvalue) => setFieldValue('secondary_email', newvalue)}
                        helpText="The email field accepts multiple inputs. Please enter emails by typing and press Enter."
                      />
                    </Grid>
                    <Grid item xs={4} xl={4}>
                      <Field
                        name="department_id"
                        component={Autocomplete}
                        className="CurrencyField"
                        multiple
                        value={values.department_id}
                        options={activeDeptData ?? []}
                        filterSelectedOptions
                        // disableClearable
                        isOptionEqualToValue={(option, value) => option.name === value.name}
                        onChange={(e, newvalue) => {
                          setFieldValue('department_id', newvalue);
                        }}
                        loading={isLoading}
                        getOptionLabel={(option) => option.name}
                        renderTags={(value, getTagProps) =>
                          value.map((option, index) => (
                            // eslint-disable-next-line react/no-array-index-key
                            <div className="tagsValue" key={index}>
                              <Chip
                                size="small"
                                sx={{ maxWidth: '60px!important' }}
                                color="secondary"
                                variant="outlined"
                                label={option.name}
                                {...getTagProps({ index })}
                                deleteIcon={<HighlightOffOutlinedIcon />}
                              />
                            </div>
                          ))
                        }
                        renderOption={(props, option) => {
                          return (
                            <li {...props} key={option._id}>
                              {option.name}
                            </li>
                          );
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            name="department_id"
                            error={touched.department_id && !!errors.department_id}
                            helperText={touched.department_id && errors.department_id}
                            label="Select Department"
                            placeholder="Search Department"
                            variant="outlined"
                            margin="normal"
                            required={false}
                            InputLabelProps={{ required: true }}
                          />
                        )}
                      />
                    </Grid>
                    <Grid item xs={4} xl={4}>
                      <Field
                        name="payment_method_id"
                        component={Autocomplete}
                        className="CurrencyField"
                        multiple
                        value={values.payment_method_id}
                        options={paymentMethodData ?? []}
                        filterSelectedOptions
                        isOptionEqualToValue={(option, value) => option.name === value.name}
                        onChange={(e, newvalue) => {
                          setFieldValue('payment_method_id', newvalue);
                        }}
                        loading={isLoading}
                        getOptionLabel={(option) => option.name}
                        renderTags={(value, getTagProps) =>
                          value.map((option, index) => (
                            // eslint-disable-next-line react/no-array-index-key
                            <div className="tagsValue" key={index}>
                              <Chip
                                size="small"
                                sx={{ maxWidth: '60px!important' }}
                                color="secondary"
                                variant="outlined"
                                label={option.name}
                                {...getTagProps({ index })}
                                deleteIcon={<HighlightOffOutlinedIcon />}
                              />
                            </div>
                          ))
                        }
                        renderOption={(props, option) => {
                          return (
                            <li {...props} key={option._id}>
                              {option.name}
                            </li>
                          );
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            name="payment_method_id"
                            error={touched.payment_method_id && !!errors.payment_method_id}
                            helperText={touched.payment_method_id && errors.payment_method_id}
                            label="Accept Payment Via"
                            placeholder="Search Payment"
                            variant="outlined"
                            margin="normal"
                            required={false}
                            InputLabelProps={{ required: false }}
                          />
                        )}
                      />
                    </Grid>
                    <Grid item xs={4} xl={4}>
                      <TextField
                        error={errors.address_1 && touched.address_1}
                        label="Address Line 1"
                        className=""
                        fullWidth
                        name="address_1"
                        value={values.address_1}
                        // maxRows={4}
                        placeholder="Enter Address Line 1"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        helperText={errors.address_1 && touched.address_1 && errors.address_1}
                        margin="normal"
                        variant="outlined"
                        required={false}
                        InputLabelProps={{ required: false }}
                      />
                    </Grid>
                    <Grid item xs={4} xl={4}>
                      <TextField
                        error={errors.address_2 && touched.address_2}
                        label="Address Line 2"
                        className=""
                        fullWidth
                        name="address_2"
                        value={values.address_2}
                        // maxRows={4}
                        placeholder="Enter Address Line 2"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        helperText={errors.address_2 && touched.address_2 && errors.address_2}
                        margin="normal"
                        variant="outlined"
                      />
                    </Grid>
                    <Grid item xs={4} xl={4}>
                      <TextField
                        id="phone"
                        fullWidth
                        label="Phone Number"
                        name="phone"
                        margin="normal"
                        placeholder="Enter Phone number"
                        value={values.phone}
                        onChange={handleChange}
                        onBlur={(e) => {
                          const val = (e.target.value || '').replace(/\s+/gi, '');
                          setFieldValue(e.target.name, val.trim());
                          handleBlur(e);
                        }}
                        error={errors.phone && touched.phone}
                        helperText={errors.phone && touched.phone && errors.phone}
                        required={false}
                        InputLabelProps={{ required: false }}
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="start">
                              <IconButton
                                aria-label="toggle password visibility"
                                edge="end"
                                disabled
                              >
                                <PhoneOutlinedIcon />
                              </IconButton>
                            </InputAdornment>
                          )
                        }}
                      />
                    </Grid>
                    <Grid item xs={4} xl={4}>
                      <Field
                        name="country_id"
                        component={Autocomplete}
                        className="CurrencyField"
                        options={countryData ?? []}
                        value={values.country_id}
                        // disableClearable
                        onChange={(e, newvalue) => {
                          setFieldValue('country_id', newvalue);
                          setFieldValue('state_id', null);
                          if (newvalue && newvalue._id) {
                            handleCountryChange(newvalue._id);
                          }
                        }}
                        loading={isLoading}
                        getOptionLabel={(option) => option.name}
                        renderOption={(props, option) => {
                          return (
                            <li {...props} key={option._id}>
                              {option.name}
                            </li>
                          );
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            name="country_id"
                            error={touched.country_id && !!errors.country_id}
                            helperText={touched.country_id && errors.country_id}
                            label="Select Country"
                            placeholder="Search Country"
                            variant="outlined"
                            margin="normal"
                            required={false}
                            InputLabelProps={{ required: false }}
                          />
                        )}
                      />
                    </Grid>
                    <Grid item xs={4} xl={4}>
                      <Field
                        name="state_id"
                        component={Autocomplete}
                        className="CurrencyField"
                        value={values.state_id}
                        options={stateData ?? []}
                        // disableClearable
                        onChange={(e, newvalue) => {
                          setFieldValue('state_id', newvalue);
                        }}
                        loading={isLoading}
                        getOptionLabel={(option) => option.name}
                        renderOption={(props, option) => {
                          return (
                            <li {...props} key={option._id}>
                              {option.name}
                            </li>
                          );
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            name="state_id"
                            error={touched.state_id && !!errors.state_id}
                            helperText={touched.state_id && errors.state_id}
                            label="Select State"
                            placeholder="Search State"
                            variant="outlined"
                            margin="normal"
                            required={false}
                            InputLabelProps={{ required: false }}
                          />
                        )}
                      />
                    </Grid>
                    <Grid item xs={4} xl={4}>
                      <TextField
                        error={errors.city && touched.city}
                        label="City"
                        className=""
                        fullWidth
                        name="city"
                        value={values.city}
                        // maxRows={4}
                        placeholder="Enter City"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        helperText={errors.city && touched.city && errors.city}
                        margin="normal"
                        variant="outlined"
                        required={false}
                        InputLabelProps={{ required: false }}
                      />
                    </Grid>
                    <Grid item xs={4} xl={4}>
                      <TextField
                        error={errors.postal_code && touched.postal_code}
                        label="Postal Code"
                        className=""
                        fullWidth
                        name="postal_code"
                        value={values.postal_code}
                        // maxRows={4}
                        placeholder="Enter Postal Code"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        helperText={errors.postal_code && touched.postal_code && errors.postal_code}
                        margin="normal"
                        variant="outlined"
                        required={false}
                        InputLabelProps={{ required: false }}
                      />
                    </Grid>
                    <Grid item xs={4} xl={4}>
                      <Field
                        name="currency_id"
                        component={Autocomplete}
                        className="CurrencyField"
                        options={currencyActiveData ?? []}
                        value={values.currency_id}
                        // disableClearable
                        onChange={(e, newvalue) => {
                          setFieldValue('currency_id', newvalue);
                        }}
                        loading={isLoading}
                        getOptionLabel={(option) => option.name}
                        renderOption={(props, option) => {
                          return (
                            <li {...props} key={option._id}>
                              {option.name}
                            </li>
                          );
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            name="currency_id"
                            error={touched.currency_id && !!errors.currency_id}
                            helperText={touched.currency_id && errors.currency_id}
                            label="Select Currency"
                            placeholder="Search Currency"
                            variant="outlined"
                            margin="normal"
                            required={false}
                            InputLabelProps={{ required: true }}
                          />
                        )}
                      />
                    </Grid>
                    <Grid item xs={4} xl={4}>
                      <Box className="datepicker">
                        <DatePicker
                          selected={values.contract_date}
                          name="contract_date"
                          dateFormat="dd MMM yyyy"
                          isClearable
                          onChange={(date) => {
                            setFieldValue('contract_date', date);
                          }}
                          customInput={
                            <TextField
                              fullWidth
                              label="Contract Date"
                              margin="normal"
                              error={touched.contract_date && Boolean(errors.contract_date)}
                              helperText={touched.contract_date && errors.contract_date}
                              InputProps={{
                                endAdornment: (
                                  <InputAdornment position="start">
                                    <IconButton aria-label="contract date" edge="end" disabled>
                                      <CalendarMonthIcon />
                                    </IconButton>
                                  </InputAdornment>
                                )
                              }}
                            />
                          }
                        />
                      </Box>
                    </Grid>
                  </Grid>
                </CardContent>
                <CardActions sx={{ justifyContent: 'center' }}>
                  <Button
                    type="submit"
                    className="save__btn"
                    variant="contained"
                    color="secondary"
                    // fullWidth
                    disabled={isSubmitting}
                    size="medium"
                  >
                    {isSubmitting ? <CircularProgress size={20} /> : 'Submit'}
                  </Button>
                  <Button
                    type="button"
                    className="cancel__btn"
                    variant="contained"
                    color="info"
                    size="medium"
                    onClick={() => {
                      handleReset();
                    }}
                  >
                    Clear
                  </Button>
                </CardActions>
              </Card>
            </form>
          )}
        </Formik>
      </Box>
    </Modal>
  );
}

ClientAdd.propTypes = {
  openmodal: PropTypes.bool.isRequired,
  onCloseModal: PropTypes.func.isRequired
};

export default ClientAdd;
